import { FC } from 'react';
import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import CommuityCard from '../community-card/community-card.component';
import { UserDataType } from '../../../services/types/user-types';
import { joinCommunitiesSectionStyles } from './join-communities-section.styles';
import { useStyles } from '../../../utils/hooks/useStyles';
import CardSlider from '../card-slider/card-slider.component';
import { usersService } from '../../../services';
import { getOthersLocation } from '../../../constants';

export interface JoinCommunitiesSectionProps {
	cityId?: string;
}

const JoinCommunitiesSection: FC<JoinCommunitiesSectionProps> = ({ cityId }) => {
	const styles = useStyles(joinCommunitiesSectionStyles);

	const { data: recomendedCommunities } = useQuery(['recomended-communities', cityId], async () =>
		usersService.findAllPublic({
			pageSize: 15,
			isCommunityProfile: true,
			isRecommendedCommunityProfile: true,
			cityIds: cityId === getOthersLocation().cityId ? undefined : [cityId],
		})
	);

	if (!recomendedCommunities?.list?.length) {
		return <></>;
	}

	return (
		<Box sx={styles.root}>
			<CardSlider
				horizPadding={0}
				sx={{ header: { p: '0' } }}
				list={recomendedCommunities?.list ?? []}
				component={(community: UserDataType) => <CommuityCard community={community} />}
				title="Join communities"
			/>
		</Box>
	);
};

export default JoinCommunitiesSection;
